import { EntityWithStatus, IEntityWithStatus } from "./EntityWithStatus";
import { IApp04AIChatUser } from "./App04AIChatUser";
import { IApp04Topic } from "./App04Topic";
import { IEntity } from "./Entity";


export interface IApp04AIChat extends IEntityWithStatus {
    TopicID?: number;
    AppID?: number;
    CreatedByUserID?: number;
    CreatedOn?: Date;
    UpdatedOn?: Date;
    LastPrompt?: string;
    LastPromptAt?: Date;
    TotalPrompts?: number;
    SummaryFrequency?: number;
    ChatContext?: string;

    Topic?: IApp04Topic;
    App04AIChatUsers?: IApp04AIChatUser[];
    App04AIChatMessages?: IEntity[];

}

export class App04AIChat extends EntityWithStatus implements IApp04AIChat {
    public AppID = null;
    public CreatedByUserID = null;
    public CreatedOn = null;
    public UpdatedOn = null;
    public LastPrompt = null;
    public LastPromptAt = null;
    public TotalPrompts = null;
    public SummaryFrequency = null;
    public ChatContext = null;

    public App04AIChatUsers = null;
}